import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=4c4d1498&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=4c4d1498&prod&scoped=true&lang=less"
import style1 from "./LeftMenu.vue?vue&type=style&index=1&id=4c4d1498&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d1498",
  null
  
)

export default component.exports